import { render, staticRenderFns } from "./PasswordResetForm.vue?vue&type=template&id=51f827af&scoped=true"
import script from "./PasswordResetForm.vue?vue&type=script&lang=js"
export * from "./PasswordResetForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-styles/login-forms.css?vue&type=style&index=0&id=51f827af&prod&scoped=true&lang=css&external"
import style1 from "./PasswordResetForm.vue?vue&type=style&index=1&id=51f827af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f827af",
  null
  
)

export default component.exports